module.exports = __webpack_public_path__ + "media/pdf/sac_logo_cmyk_fr_pos.opti-87e6f276.jpg";